import { Customer } from "./customer";
import { Model } from './model';
import { Contract } from "./contract";
import { Testbed } from "./testbed";

export class Company extends Model {

  companyName?: string;
  companyEmail?: string;
  companyAddress?: string;
  contact1email?: string;
  contact2email?: string;
  contact1phone?: string;
  contact2phone?: string;
  contact1role?: string;
  contact2role?: string;

  customers?: Customer[];

  contracts?: Contract[];
  testbeds?: Testbed[];
}
